import {StaffingDao} from '../../dao';
import {ErrorModel} from '../../models';
import { getAllStaffingSchema } from './_schema/getAllStaffing.schema';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_ALL_STAFFING';

export async function getAllStaffing(
    token: string,
    params: string,
) {
    try {
        const result = await StaffingDao.getAllStaffing(token, params);

        const parsedResult = getAllStaffingSchema.parse(result);

        return {
            data: parsedResult
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation des staffings',
            error: error
        });
    }
}
